



































import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'ConfirmModal',
    components: {},
})
export default class ConfirmModal extends Vue {
    public confirm() {
        this.$emit('toggleConfirmModal', true);
    }

    public toggleModal() {
        this.$emit('toggleConfirmModal', false);
    }
}
